import React from 'react';

const WORK_TOOLS = [
  '🏢 Leadership Hub',
  '📤 Aufgaben & Delegation',
  '📝 Meeting-Analyse',
  '🧠 Wissensarchiv',
  '💼 Leadership Coach',
  '📋 SOP-Generator',
  '🔍 Problem Analyzer',
  '🎉 Team-Event-Planung',
];

const LIFE_TOOLS = [
  '🛒 VoiceCart',
  '🍳 Rezeptgenerator',
  '⚖️ BMI-Rechner',
  '🥗 Gewichtsprognose',
  '🧭 Job-Kompass',
  '💡 KI-Assistent',
];

function Products() {
  return (
    <section className="products" id="products">
      <div className="section-header">
        <h2>Zwei Plattformen. Ein Ziel.</h2>
        <p>Mehr Struktur, bessere Entscheidungen und weniger Stress – für Beruf und Alltag.</p>
      </div>

      <div className="products-grid products-grid--asymmetric">
        {/* Work – Hauptprodukt */}
        <div className="product-card product-card--work" id="work">
          <div className="product-card__icon product-card__icon--img">
            <img src="/techsoulwork.png" alt="TechSoul Work" />
          </div>
          <div className="product-card__badge product-card__badge--work">TechSoul Work</div>
          <h3>Führungssystem für Teams</h3>
          <p>
            Für Führungskräfte, Projektleiter und Operations Teams.
            TechSoul Work verbindet Aufgabenmanagement, Wissensarchiv, Meeting-Analyse,
            Entscheidungsdokumentation und Verantwortungsnachverfolgung in einer zentralen Plattform.
          </p>
          <ul className="product-card__tools">
            {WORK_TOOLS.map(t => <li key={t}>{t}</li>)}
          </ul>
          <a href="/registrieren" className="product-card__btn product-card__btn--work">Zugang einrichten →</a>
        </div>

        {/* Life – Ergänzendes Produkt */}
        <div className="product-card product-card--life product-card--secondary" id="life">
          <div className="product-card__icon product-card__icon--img">
            <img src="/techsoullife.png" alt="TechSoul Life" />
          </div>
          <div className="product-card__badge product-card__badge--life">TechSoul Life</div>
          <h3>Für den Alltag</h3>
          <p>KI-Werkzeuge für Ernährung, Planung und persönliche Entwicklung.</p>
          <ul className="product-card__tools">
            {LIFE_TOOLS.map(t => <li key={t}>{t}</li>)}
          </ul>
          <a href="/registrieren" className="product-card__btn product-card__btn--life">Zugang einrichten →</a>
        </div>
      </div>
    </section>
  );
}

export default Products;
